module.exports = __webpack_public_path__ + "static/img/sold-out.c9665446.png";